import {useAnalysisProcessSteps} from "./useAnalysisProcessSteps.tsx";
import {StepsWrapper} from "../components/stepper/StepsWrapper.tsx";

export function AnalysisProcess() {
    const stepsList = useAnalysisProcessSteps()
    return <StepsWrapper steps={stepsList} />
}